// extracted by mini-css-extract-plugin
module.exports = {"comments":"item_comments__tDBeT","other":"item_other__nIZI2","fullItemContainer":"item_fullItemContainer__ZAYtZ"};